(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("FEGORender"));
	else if(typeof define === 'function' && define.amd)
		define(["FEGORender"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/web-community-discussion-list/render"] = factory(require("FEGORender"));
	else
		root["/fego/component/web-community-discussion-list/render"] = factory(root["FEGORender"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__5322__) => {
return 